// extracted by mini-css-extract-plugin
export var AddToCartContainer = "single-product-module--AddToCartContainer--fe3a3";
export var ArtworkName = "single-product-module--ArtworkName--06b56";
export var PDPAuthor = "single-product-module--PDPAuthor--8544f";
export var RecentBlogImage = "single-product-module--RecentBlogImage--c5765";
export var RecentBlogheading = "single-product-module--RecentBlogheading--c5be6";
export var SliderContainer = "single-product-module--SliderContainer--11285";
export var artistImage = "single-product-module--artistImage--15121";
export var artistItem = "single-product-module--artistItem--7529f";
export var artistTitle = "single-product-module--artistTitle--cc6e0";
export var artworkImages = "single-product-module--artworkImages--0f592";
export var auctionCard = "single-product-module--auctionCard--b127f";
export var auctionCardsContainer = "single-product-module--auctionCardsContainer--bf640";
export var auctionData = "single-product-module--auctionData--77da3";
export var auctionImage = "single-product-module--auctionImage--c0951";
export var authorImage = "single-product-module--authorImage--344f7";
export var autionTitle = "single-product-module--autionTitle--f39a3";
export var blueDarkbutton = "single-product-module--blueDarkbutton--7a37a";
export var bluedDarkbutton = "single-product-module--bluedDarkbutton--2d577";
export var colMedia = "single-product-module--colMedia--21e93";
export var colProduct = "single-product-module--colProduct--3ebf1";
export var column = "single-product-module--column--ee81c";
export var columnOne = "single-product-module--columnOne--1036f";
export var columnTwo = "single-product-module--columnTwo--d7d38";
export var container = "single-product-module--container--a06b0";
export var containerMedia = "single-product-module--containerMedia--240b4";
export var desktopxd = "single-product-module--desktopxd--06489";
export var emaContainer = "single-product-module--emaContainer--27153";
export var hrSpec = "single-product-module--hrSpec--49c6a";
export var hrSpecOne = "single-product-module--hrSpecOne--14ad6";
export var imgPad = "single-product-module--imgPad--4d383";
export var listingContainerStyle = "single-product-module--listingContainerStyle--7b335";
export var mandatpad = "single-product-module--mandatpad--187e3";
export var minTagHeight = "single-product-module--minTagHeight--9aa37";
export var mobpadHead = "single-product-module--mobpadHead--9747c";
export var muiPad = "single-product-module--muiPad--977be";
export var newsContainer = "single-product-module--newsContainer--b6ffb";
export var pdpImageslider = "single-product-module--pdpImageslider--beebf";
export var pdpSubheading = "single-product-module--pdpSubheading--73e65";
export var pdpUrl = "single-product-module--pdpUrl--edddc";
export var productContainer = "single-product-module--productContainer--9f305";
export var rowOne = "single-product-module--rowOne--b41dd";
export var sPad = "single-product-module--sPad--55afc";
export var saumlContainer = "single-product-module--saumlContainer--672c7";
export var slickActive = "single-product-module--slick-active--2a641";
export var slickDots = "single-product-module--slick-dots--930af";
export var slickFade = "single-product-module--slick-fade--7ea33";
export var slickSlide = "single-product-module--slick-slide--8dcff";
export var smalpad = "single-product-module--smalpad--86d0e";
export var soldOut = "single-product-module--soldOut--1f6b8";
export var specification = "single-product-module--specification--4db8e";
export var subsectionTitles = "single-product-module--subsectionTitles--45b79";
export var test = "single-product-module--test--c962c";
export var testcontainer = "single-product-module--testcontainer--aba8a";
export var testmaincontainer = "single-product-module--testmaincontainer--01151";
export var thumbnailSliderWrapper = "single-product-module--thumbnailSliderWrapper--4b9ed";
export var title = "single-product-module--title--7d009";
export var twoColumnContainer = "single-product-module--twoColumnContainer--9ec72";